export const menuData = [
  {
    key: 1,
    activeKey: 0,
    title: 'Add Institute',
    heading: 'Add Institute',
  },
  {
    key: 2,
    activeKey: 1,
    title: 'Tax Info',
    heading: 'Tax Info',
  },
  {
    key: 3,
    activeKey: 2,
    title: 'Add Partners',
    heading: 'Add Partners',
  },
  {
    key: 4,
    activeKey: 3,
    title: 'Pricing and Contract',
    heading: 'Pricing and Contract',
  },
]
